import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	titleWrapper: {
		paddingBlock: token('space.100'),
	},
});

export const Title = ({ title }: { title: string }): React.JSX.Element => {
	return (
		<Box xcss={styles.titleWrapper}>
			<Text color="color.text.subtlest" size="small" weight="semibold">
				{title}
			</Text>
		</Box>
	);
};
